// react
import { Suspense, lazy } from "react";
import { Outlet } from "react-router-dom";
// layouts
import MapLayout from "src/layouts/map/map-layout";
// sections
import { mapDisplayRoutes } from "src/routes/sections/map-display";
import { generalRoutes } from "./General";
import { conversionRoutes } from "src/routes/sections/conversion";
import { layersRoutes } from "src/routes/sections/layers";
import { dataGeneratorRoutes } from "src/routes/sections/data-generator";
import { RoutingRoutes } from "src/routes/sections/routing";
import { GeocodingRoutes } from "./geo-coding";
import Profile from "src/components/UI/Profile/index";
import AuthGuard from "src/guard/AuthGuard";
import ContactUs from "src/components/UI/Contact/contact-us";
import Verify from "src/components/Verify/verify";

export const homeRoutes = [
  {
    path: "/",
    element: (
      <MapLayout>
        <Suspense>
          <Outlet />
        </Suspense>
      </MapLayout>
    ),
    children: [
      ...mapDisplayRoutes,
      ...conversionRoutes,
      ...layersRoutes,
      ...dataGeneratorRoutes,
      ...generalRoutes,
      ...RoutingRoutes,
      ...GeocodingRoutes,
      {
        path: "profile",
        element: (
          <AuthGuard>
            <Profile />
          </AuthGuard>
        ),
      },
      {
        path: "contact-us",
        element: <ContactUs />,
      },
      {
        path: "verify",
        element: <Verify />,
      },
      // { path: "print-to", element: <PrintToPage /> },
    ],
  },
];
